import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { UpdateEmailFileEntryResponse } from '@/src/components/project/Inbox2/api/updateEmailFileStatus';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { emailFileActivityLogsKeys } from './getEmailFileActivityLogs';
import { emailFileDetailsKeys } from './getEmailFileDetails';

// const url = `${PREFIX_URL}/v01/inbox/isMisc`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId/attachments/:fileId`;

export type MarkMiscellaneousDTO = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  fileId: number;
  misc: boolean;
};

export const markMiscellaneous = ({
  projectId,
  inboxEntryId,
  emailId,
  fileId,
  misc,
}: MarkMiscellaneousDTO): Promise<UpdateEmailFileEntryResponse> => {
  return axios.put(generateRoutePath(url, { projectId, inboxEntryId, emailId, fileId }), {
    misc,
  });
};

type useMarkMiscellaneousOptions = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  fileId: number;
  config?: MutationConfig<typeof markMiscellaneous>;
};

export const useMarkMiscellaneousEmailFile = ({
  projectId,
  inboxEntryId,
  emailId,
  fileId,
  config,
}: useMarkMiscellaneousOptions) => {
  return useMutation({
    onSuccess: (data) => {
      queryClient.setQueryData(
        [...emailFileDetailsKeys.detail({ projectId, emailId, inboxEntryId, fileId })],
        (prev: any) => {
          return {
            ...prev,
            data: data.data['inbox-email-attachment'],
          };
        }
      );

      queryClient.invalidateQueries([
        ...emailFileActivityLogsKeys.detail({ projectId, fileId, emailId, inboxEntryId }),
      ]);
    },
    ...config,
    mutationFn: ({ misc }) => markMiscellaneous({ inboxEntryId, emailId, projectId, fileId, misc }),
  });
};
